module.exports = __webpack_public_path__ + "media/flags/se-a099a957.svg";